import api from "../../api";

// initial state
const state = {
  user: {
    subscription: null,
    websites: [],
    id: -1,
    email: ""
  }
};

// getters
const getters = {
  user: (state, getters, rootState) => {
    return state.user;
  },
  userLoggedIn: (state, getters, rootState) => {
    console.log("Is user logged in???");
    console.log(state);
    return state.user.id >= 0;
  },
  usersWebsite: (state, getters, rootState) => {
    if (state.user.websites.length === 0) return {};
    return state.user.websites[0];
  },
  userHasWebsite: (state, getters, rootState) => {
    console.log("PREMIUM????");
    console.log(state.user);
    return Object.keys(getters.usersWebsite).length > 0;
  },
  hasPremium: (state, getters, rootState) => {
    return state.user.subscription && state.user.subscription.active;
  },
  componentsMonitoredLimit: (state, getters, rootState) => {
    if (state.user.subscription) return 8;
    return 3;
  }
};

// actions
const actions = {
  async auth({ commit }) {
    const data = await api.auth();
    const user = data.user;
    if (user && user.id) {
      commit("updateUser", user);
      localStorage.user = JSON.stringify(user);
    } else {
      localStorage.removeItem("user");
    }
  }
};

// mutations
const mutations = {
  updateUser(state, user) {
    state.user = user;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
